import {BlockBuilder} from '../../classes/blockBuilder';
import {BlockType} from '../../classes/blockType';

export const _shadow_ = new BlockType({
  name: '_shadow_',
  title: '_shadow_',
  compatibility: [],
  builder: () => BlockBuilder.create('_shadow_'),
});
